export default function Industries() {
  return (
    <section id="industries" className="py-12 md:py-24 px-4 sm:px-6 lg:px-16 bg-white relative overflow-hidden">
      <div className="absolute top-20 left-1/4 w-72 h-72 bg-[#F49729]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 right-1/4 w-64 h-64 bg-[#F49729]/5 rounded-full blur-3xl"></div>

      <div className="max-w-6xl mx-auto text-center mb-8 md:mb-14 relative z-10">
        <p className="text-[#F49729] text-[10px] md:text-xs font-semibold tracking-[0.25em] uppercase mb-3 md:mb-4">
          Work with Us
        </p>
        <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-[#111111] leading-tight">
          Why Companies Choose Us
        </h2>
      </div>

      <div className="flex justify-center relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 lg:gap-8 w-full max-w-sm sm:max-w-lg md:max-w-none">
          {[
            { icon: 'ri-time-line', title: 'Overlapping Hours', label: 'Real-time collaboration during your business day' },
            { icon: 'ri-user-search-line', title: 'Hand-Screened', label: 'No mass resume dumps, every profile reviewed first' },
            { icon: 'ri-global-line', title: 'Work-Ready', label: 'Fluent in English, trained on accounting software' },
            { icon: 'ri-flashlight-line', title: 'Fast Shortlist', label: 'Candidates in days, not weeks' },
          ].map((item, i) => (
            <div
              key={i}
              className="text-center p-4 md:p-6 rounded-2xl md:rounded-3xl bg-gradient-to-br from-[#faf9f7] to-white border border-gray-50 hover:shadow-lg hover:shadow-[#F49729]/5 transition-all duration-300"
            >
              <span className="inline-flex w-9 h-9 md:w-11 md:h-11 items-center justify-center rounded-xl bg-[#F49729]/10 text-[#F49729] mb-2 md:mb-3">
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </span>
              <p className="text-sm sm:text-base md:text-lg font-bold text-[#111111] mb-1">{item.title}</p>
              <p className="text-[10px] sm:text-xs text-[#7F7F84] leading-snug">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
